import React from "react";
import Box from "@mui/material/Box";
import FdTextField from "../UIComponents/TextField/FdTextfield";

// interface FormData {
//   name: string;
//   label: string;
// }

const InfoFieldForm = () => {
  // async function validate(values: FormData) {
  //   if (!values.name) {
  //     return { email: "Required" };
  //   }

  //   if (!values.label) {
  //     return { message: "Required" };
  //   }

  //   return;
  // }
  // const errorMsg = "required"
  return (
    <Box>
        {/* Infofield Name */}
        <FdTextField name="name" id="customFieldName" label="Infofield Name" required />

        {/* Infofield Value */}
        <FdTextField
          name="label"
          id="customFieldLabel"
          label="Infofield Label"
        />
    </Box>
  );
};

export default InfoFieldForm;
